<template>
	<div class="juniper-breadcrumb">
		<router-link class="btn btn-primary mb-2" :to="back">
			<font-awesome-icon :icon="['fas', 'arrow-circle-left']" class="me-1" />
			Back
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" to="/">🏠 MC2</router-link>
		<a
			v-if="!hideDashboard"
			:href="dashboardUrl + '?url=' + (client.staging ? client.staging_url : client.url) + '&user=' + authUser.email + '&password=' + tokenJuniper"
			target="_blank"
			class="btn btn-primary mb-2 ms-2 float-end"
			title="Go to TW Dashboard"
			to="/"
		>
			<font-awesome-icon :icon="['fas', 'fingerprint']" class="me-1" />
			Dashboard
		</a>
		<a
			v-if="showWebsiteUrl"
			target="_blank"
			title="Visit website"
			class="btn btn-primary mb-2 ms-2 float-end"
			:href="client.staging ? client.staging_url : client.url"
			><font-awesome-icon :icon="['fas', 'globe-americas']"
		/></a>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import juniperApi from '../../../api/juniperApi'
export default {
	name: 'Breadcrumb',
	components: {},
	data() {
		return {
			dashboardUrl: process.env.VUE_APP_DASHBOARD_URL,
			client: {},
		}
	},
	props: {
		back: String,
		hideDashboard: Boolean,
		showWebsiteUrl: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapState(['authUser', 'tokenJuniper']),
		...mapGetters(['isAuth']),
	},
	created() {
		this.getClient()
	},
	methods: {
		// Get client
		getClient() {
			if (this.$route.params.id) {
				this.loading = true
				juniperApi
					.get('/clients/' + this.$route.params.id)
					.then(({ data }) => {
						this.client = data
						this.loading = false
					})
					.catch(error => {
						this.loading = false
						console.log(error)
					})
			}
		},
	},
}
</script>
